var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({ref:"editor",staticClass:"viewer__image-editor"},'div',_vm.themeDataAttr,false))}
var staticRenderFns = []

export { render, staticRenderFns }